module.exports = __webpack_public_path__ + "assets/logo_vertical.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_vertical.png
 ** module id = 145
 ** module chunks = 1
 **/